import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import Hammer from '@egjs/hammerjs';
import State from "../State";
import { CONTENT_TOUCHES_DELAY, CONTENT_TOUCHES_QUICK_TAP_END_DELAY } from "./constants";
import DiscreteGestureHandler from "./DiscreteGestureHandler";
import { fireAfterInterval, isValidNumber, isnan } from "./utils";

var PressGestureHandler = function (_DiscreteGestureHandl) {
  _inherits(PressGestureHandler, _DiscreteGestureHandl);

  var _super = _createSuper(PressGestureHandler);

  function PressGestureHandler() {
    var _this;

    _classCallCheck(this, PressGestureHandler);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.shouldDelayTouches = true;
    return _this;
  }

  _createClass(PressGestureHandler, [{
    key: "simulateCancelEvent",
    value: function simulateCancelEvent(inputData) {
      this.hasGestureFailed = true;
      this.cancelEvent(inputData);
    }
  }, {
    key: "updateHasCustomActivationCriteria",
    value: function updateHasCustomActivationCriteria(_ref) {
      var shouldCancelWhenOutside = _ref.shouldCancelWhenOutside,
          maxDistSq = _ref.maxDistSq;
      return shouldCancelWhenOutside || !isValidNumber(maxDistSq);
    }
  }, {
    key: "getState",
    value: function getState(type) {
      var _Hammer$INPUT_START$H;

      return (_Hammer$INPUT_START$H = {}, _defineProperty(_Hammer$INPUT_START$H, Hammer.INPUT_START, State.BEGAN), _defineProperty(_Hammer$INPUT_START$H, Hammer.INPUT_MOVE, State.ACTIVE), _defineProperty(_Hammer$INPUT_START$H, Hammer.INPUT_END, State.END), _defineProperty(_Hammer$INPUT_START$H, Hammer.INPUT_CANCEL, State.CANCELLED), _Hammer$INPUT_START$H)[type];
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      if (!this._hasCustomActivationCriteria) {
        return {
          shouldCancelWhenOutside: true,
          maxDistSq: 10
        };
      }

      return this.config;
    }
  }, {
    key: "getHammerConfig",
    value: function getHammerConfig() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(PressGestureHandler.prototype), "getHammerConfig", this).call(this)), {}, {
        time: this.minDurationMs
      });
    }
  }, {
    key: "onGestureActivated",
    value: function onGestureActivated(ev) {
      this.onGestureStart(ev);
    }
  }, {
    key: "shouldDelayTouchForEvent",
    value: function shouldDelayTouchForEvent(_ref2) {
      var pointerType = _ref2.pointerType;
      return this.shouldDelayTouches && pointerType === 'touch';
    }
  }, {
    key: "onGestureStart",
    value: function onGestureStart(ev) {
      var _this2 = this;

      this.isGestureRunning = true;
      clearTimeout(this.visualFeedbackTimer);
      this.initialEvent = ev;
      this.visualFeedbackTimer = fireAfterInterval(function () {
        _this2.sendGestureStartedEvent(_this2.initialEvent);

        _this2.initialEvent = null;
      }, this.shouldDelayTouchForEvent(ev) && CONTENT_TOUCHES_DELAY);
    }
  }, {
    key: "sendGestureStartedEvent",
    value: function sendGestureStartedEvent(ev) {
      clearTimeout(this.visualFeedbackTimer);
      this.visualFeedbackTimer = null;
      this.sendEvent(_objectSpread(_objectSpread({}, ev), {}, {
        eventType: Hammer.INPUT_MOVE,
        isFirst: true
      }));
    }
  }, {
    key: "forceInvalidate",
    value: function forceInvalidate(event) {
      _get(_getPrototypeOf(PressGestureHandler.prototype), "forceInvalidate", this).call(this, event);

      clearTimeout(this.visualFeedbackTimer);
      this.visualFeedbackTimer = null;
      this.initialEvent = null;
    }
  }, {
    key: "onRawEvent",
    value: function onRawEvent(ev) {
      var _this3 = this;

      _get(_getPrototypeOf(PressGestureHandler.prototype), "onRawEvent", this).call(this, ev);

      if (ev.isFinal && this.isGestureRunning) {
        var timeout;

        if (this.visualFeedbackTimer) {
          timeout = CONTENT_TOUCHES_QUICK_TAP_END_DELAY;
          this.sendGestureStartedEvent(this.initialEvent);
          this.initialEvent = null;
        }

        fireAfterInterval(function () {
          _this3.sendEvent(_objectSpread(_objectSpread({}, ev), {}, {
            eventType: Hammer.INPUT_END,
            isFinal: true
          }));

          _this3.onGestureEnded();
        }, timeout);
      }
    }
  }, {
    key: "updateGestureConfig",
    value: function updateGestureConfig(_ref3) {
      var _ref3$shouldActivateO = _ref3.shouldActivateOnStart,
          shouldActivateOnStart = _ref3$shouldActivateO === void 0 ? false : _ref3$shouldActivateO,
          _ref3$disallowInterru = _ref3.disallowInterruption,
          disallowInterruption = _ref3$disallowInterru === void 0 ? false : _ref3$disallowInterru,
          _ref3$shouldCancelWhe = _ref3.shouldCancelWhenOutside,
          shouldCancelWhenOutside = _ref3$shouldCancelWhe === void 0 ? true : _ref3$shouldCancelWhe,
          _ref3$minDurationMs = _ref3.minDurationMs,
          minDurationMs = _ref3$minDurationMs === void 0 ? Number.NaN : _ref3$minDurationMs,
          _ref3$maxDist = _ref3.maxDist,
          maxDist = _ref3$maxDist === void 0 ? Number.NaN : _ref3$maxDist,
          _ref3$minPointers = _ref3.minPointers,
          minPointers = _ref3$minPointers === void 0 ? 1 : _ref3$minPointers,
          _ref3$maxPointers = _ref3.maxPointers,
          maxPointers = _ref3$maxPointers === void 0 ? 1 : _ref3$maxPointers,
          props = _objectWithoutProperties(_ref3, ["shouldActivateOnStart", "disallowInterruption", "shouldCancelWhenOutside", "minDurationMs", "maxDist", "minPointers", "maxPointers"]);

      return _get(_getPrototypeOf(PressGestureHandler.prototype), "updateGestureConfig", this).call(this, _objectSpread({
        shouldActivateOnStart: shouldActivateOnStart,
        disallowInterruption: disallowInterruption,
        shouldCancelWhenOutside: shouldCancelWhenOutside,
        minDurationMs: minDurationMs,
        maxDist: maxDist,
        minPointers: minPointers,
        maxPointers: maxPointers
      }, props));
    }
  }, {
    key: "name",
    get: function get() {
      return 'press';
    }
  }, {
    key: "minDurationMs",
    get: function get() {
      return isnan(this.config.minDurationMs) ? 5 : this.config.minDurationMs;
    }
  }, {
    key: "maxDist",
    get: function get() {
      return isnan(this.config.maxDist) ? 9 : this.config.maxDist;
    }
  }, {
    key: "NativeGestureClass",
    get: function get() {
      return Hammer.Press;
    }
  }]);

  return PressGestureHandler;
}(DiscreteGestureHandler);

export default PressGestureHandler;